export const notFoundRoute = () => ({
  pageId: 'pageNotFound',
  pageType: 'landingpage',
  pageSection: 'tv',
  path: '*',
  remixRoute: 'PageNotFound.remix-route.tsx'
});
export const notFoundPath = () => '/not-found';